import type { CSSProperties } from 'react';

export function FixbotIcon({ className, style }: { className?: string; style?: CSSProperties }) {
   return (
      <svg viewBox="0 0 23 18" fill="none" className={className} style={style}>
         <path
            fill="currentColor"
            d="M2.8999 6.5H2.3999C1.55615 6.5 0.899902 7.1875 0.899902 8V11C0.899902 11.8438 1.55615 12.5 2.3999 12.5H2.8999V6.5Z"
         />
         <path
            fill="currentColor"
            d="M22.8999 8C22.8999 7.1875 22.2124 6.5 21.3999 6.5H20.8999V12.5H21.3999C22.2124 12.5 22.8999 11.8438 22.8999 11V8Z"
         />
         <path
            fill="currentColor"
            d="M7.3999 10.25C7.3999 9.55964 7.95955 9 8.6499 9C9.34026 9 9.8999 9.55964 9.8999 10.25V11.25C9.8999 11.9404 9.34026 12.5 8.6499 12.5C7.95955 12.5 7.3999 11.9404 7.3999 11.25V10.25Z"
         />
         <path
            fill="currentColor"
            d="M13.8999 10.25C13.8999 9.55964 14.4595 9 15.1499 9C15.8403 9 16.3999 9.55964 16.3999 10.25V11.25C16.3999 11.9404 15.8403 12.5 15.1499 12.5C14.4595 12.5 13.8999 11.9404 13.8999 11.25V10.25Z"
         />
         <path
            fill="currentColor"
            d="M14.2446 0.509766C14.9113 0.586338 15.4283 1.0971 15.5444 1.72949C18.0584 2.44458 19.8999 4.75667 19.8999 7.5V11.5C19.8999 14.8137 17.2136 17.5 13.8999 17.5H9.8999C6.58619 17.5 3.8999 14.8137 3.8999 11.5V7.5C3.8999 4.757 5.74085 2.44488 8.25439 1.72949C8.37045 1.09702 8.88844 0.586355 9.55518 0.509766L9.72998 0.5H14.0698L14.2446 0.509766ZM15.1411 4.29395L15.1089 4.42285C14.9356 5.01387 14.4167 5.4399 13.8032 5.49414L13.6704 5.5H10.1294L9.99658 5.49414C9.38311 5.4399 8.86423 5.01387 8.69092 4.42285L8.65869 4.29395L8.44775 3.24023C6.67514 3.84435 5.3999 5.52293 5.3999 7.5V11.5C5.3999 13.9853 7.41462 16 9.8999 16H13.8999C16.3852 16 18.3999 13.9853 18.3999 11.5V7.5C18.3999 5.5226 17.1241 3.84409 15.3511 3.24023L15.1411 4.29395ZM10.1294 4H13.6704L14.0698 2H9.72998L10.1294 4Z"
         />
         <path
            fill="currentColor"
            d="M9.8999 13.5H13.8999V14C13.8999 14.5523 13.4522 15 12.8999 15H10.8999C10.3476 15 9.8999 14.5523 9.8999 14V13.5Z"
         />
      </svg>
   );
}
